import { SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const ViewWrapperNewPaperStyles: SxProps<Theme> = {
  backgroundColor: '#F3F7FB',
  boxSizing: 'border-box',
  gap: 0,
  height: '100%',
  minHeight: '100%',
  overflowY: 'auto',
  p: { md: 3, xs: 1.5 },
  width: '100%',
};

export const viewPageContentStyles: SystemStyleObject<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  margin: '0 auto',
  maxWidth: '1280px',
  width: '100%',
};

export const viewPageActionsStyles: SystemStyleObject<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  minWidth: 0,
  width: '100%',
};

export const viewPageCardStyles: SystemStyleObject<Theme> = {
  backgroundColor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 3,
  boxShadow: '0 10px 26px rgba(23, 33, 43, 0.04)',
  minWidth: 0,
  overflowX: 'auto',
  p: { md: 1.5, xs: 0.75 },
};

export const viewPageTableStyles: SxProps = {
  '& .MuiTableCell-root': {
    borderBottom: '1px solid',
    borderColor: 'divider',
    py: 1.5,
    verticalAlign: 'middle',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: '#F1F5F9',
    borderBottom: 'none',
    color: 'text.secondary',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.01em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableHead-root .MuiTableSortLabel-root': {
    color: 'inherit',
  },
  minWidth: 840,
  width: '100%',
};
